var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var GRADE_LEVEL_POSITIONS = [
    'below',
    'meets',
    'above',
];
export var filterStudentsPassedPT = function (students) {
    return students.filter(function (el) { return el.ptCompletion; });
};
export var filterStudentsNotPassedPTNames = function (students) {
    return students.filter(function (el) { return !el.ptCompletion; }).map(function (el) { return el.name; });
};
export var groupStudentsByGradeLevel = function (students) {
    return GRADE_LEVEL_POSITIONS.reduce(function (acc, level) {
        var _a;
        return __assign(__assign({}, acc), (_a = {}, _a[level] = students.filter(function (el) { return el.currentGrade.position === level; }), _a));
    }, {});
};
export var mergeStudents = function (currentStudents, selectedStudents) {
    return selectedStudents.reduce(function (acc, student) {
        if (acc.some(function (el) { return el.id === student.id; }))
            return acc;
        acc.push(student);
        return acc;
    }, __spreadArray([], currentStudents, true));
};
export var filterStudents = function (currentStudents, selectedStudents) {
    return currentStudents.filter(function (student) { return !selectedStudents.some(function (el) { return el.id === student.id; }); });
};
var countGroupStudents = function (students, position) {
    return students.reduce(function (acc, current) {
        var _a;
        if (((_a = current.currentGrade) === null || _a === void 0 ? void 0 : _a.position) === position) {
            acc += 1;
        }
        return acc;
    }, 0);
};
export var getSelectedGroups = function (students, selectedStudents) {
    return GRADE_LEVEL_POSITIONS.filter(function (position) {
        return students[position].length ===
            countGroupStudents(selectedStudents, position);
    });
};
export var getUniqueGradeNames = function (students) {
    return students.reduce(function (acc, current) {
        var shortName = current.currentGrade.shortName;
        if (!acc.includes(shortName))
            acc.push(shortName);
        return acc;
    }, []);
};
